// BroncoSDK.js
class BroncoSDK {
    constructor(config = {}) {
        this.baseURL = config.baseURL || '';
        this.session = null;
        this.userUUID = null;
    }

    // Set auth details
    setAuth(session, userUUID) {
        this.session = session;
        this.userUUID = userUUID;
    }

    // Clear auth details
    clearAuth() {
        this.session = null;
        this.userUUID = null;
    }

    // Get common headers
    getHeaders(includeContentType = false) {
        const headers = {
            'X-Auth-Session': this.session,
            'X-User-UUID': this.userUUID,
        };

        if (includeContentType) {
            headers['Content-Type'] = 'application/json';
        }

        return headers;
    }

    // Generic request method
    async request(endpoint, options = {}) {
        const url = `${this.baseURL}${endpoint}`;
        const headers = this.getHeaders(!!options.body);

        console.log('API Request', url, options);

        try {
            const response = await fetch(url, {
                headers,
                ...options,
                body: options.body ? JSON.stringify(options.body) : undefined,
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();
            return data;
        } catch (error) {
            console.error('API Request failed:', error);
            throw error;
        }
    }

    async getAnalyticsProofOfPlay() {
        return this.request('/brood/pop/analytics', {
            method: 'GET'
        });
    }

    async getUserPermissions() {
        return this.request(`/user/${this.userUUID}/permissions`, {
            method: 'GET'
        });
    }
}

export default BroncoSDK;